

    <div class="uk-child-width-1-1@s" uk-grid>
        <div>
            <div class="uk-background-cover uk-height-large uk-panel uk-flex-center uk-flex-middle"
                style="background-image: url(../../assets/pythonbanner.png);">
                <div class="uk-section uk-light">
                    <div class="uk-container-small uk-width-2xlarge" style="padding-top: 50px;">
                        <div><h1 class="uk-text-bold uk-padding-large uk-padding-remove-vertical"  style="margin-bottom: 10px;">Python Application Development</h1></div>
                        <div>
                            <p class="uk-padding-large uk-text-left  uk-padding-remove-vertical" style= "font-size: 20px;">WebsoulLabs is
                                 one of the most trusted Python development companies in Kerala  that provides services in developing
                                  software and mobile applications.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
   
   
    
    
      
   
    <div class="uk-section uk-section-default" style="padding-top: 60px;">
        <div class="uk-container">
            <p class="uk-text-medium uk-text-justify" style="font-size: 18px;">Python is object-oriented,
                 interpreted, and a high-level programming language. It has incredible built-in data
                  structures that are combined with the dynamic typing and binding to render hassle-free
                   app development. It serves as a scripting language to combine several components together.
                    It is well renowned for its simple and easy-to-learn syntax which supports readability
                     and reduces the expenses incurred in the program maintenance. It also favors modules and
                      packages, which in return promote modularity and code reusability.</p>
                <br><br>
            <div class="uk-column-1-2@s">
                <h2 style="font-weight: 600;">An Overview to Python Development</h2>
                <p class="uk-text-medium uk-text-justify" style="font-size: 18px;">WebsoulLabs is a top-notch
                     python application development company and our technical experts facilitates world-class 
                     user experience by keeping in mind the client's business requirements. Our python mobile
                      app development services always cross the boundaries of innovation to deliver 
                      high-performance apps for your business ideas. Python development will be the best
                       solution for your business if you are on a budget. It is an ideal option for business
                        startups because of its quick .</p>
                <div>
                    <img data-src="assets/p4.jpg" width="600" height="600" alt="" uk-img>
                </div>
            </div>
            <br>
            <div class="uk-column-1-2@s">
                <div>
                    <img data-src="assets/p5.jpg" width="600" height="600" alt="" uk-img>
                </div>
                <p class="uk-text-medium uk-text-justify" style="font-size: 18px;">Python can be utilized
                     for the development of APIs of mobile applications. The mobile app developers can develop
                      apps using Python as it is capable of running on several major operating systems. In
                       addition to this, the rise in the number of mobile phone users and the increase in 
                       demand for applications led to the use of this programming language to develop mobile
                        applications. In recent years, Python has evolved to become a vital option in the app 
                        development market. Python can be used in a wide range of mobile application areas.
                         Easy to understand, interact and easy to implement, Python programming language is
                          an effective language that allows you to code the same. </p>
               
            </div>
        </div>  <!--container div-->
    </div>  <!--div after banner-->

    <div class="uk-section  uk-padding" style=" background-color: #135796; padding-bottom: 0px;">
        <div class="uk-container uk-container-large ">
            <h4 class="uk-text-center  uk-grid-medium " style="color: snow; font-size: 18px;">Python is one
                 of the most readable languages in the world right now. This language is very popular among
                  software developers and is widely used by many programmers in order to create mobile 
                  applications and programs.
            </h4>
        
            
            <div class="uk-grid-match uk-grid-collapse uk-child-width-expand@s  uk-padding uk-text-center"style="padding-top: 20px; padding-bottom: 20px;" uk-grid>
                <div>
                    <div class="uk-card uk-card-muted  uk-card-body" style="padding-top: 0px; padding-bottom: 0px;">
                        
                        <div class="pa">
                            <span class="text-white">
                            <img src="../../assets/SCons.png"  width="60" height="60" alt="svg"  ></span>
                            <h3 class="uk-text-center" style="color: snow; margin-top: 0px;"><strong>SCons</strong></h3>
                        </div>
                        
                       
                    </div>
                </div>
                <div>
                    <div class="uk-card uk-card-muted  uk-card-body" style="padding-top: 0px; padding-bottom: 0px;">
                        <div class="pa1">
                            <span class="text-white">
                            <img src="../../assets/apache.png"  width="60" height="60" alt="svg" style="padding-top: 15px"  ></span>
                            <h3 class="uk-text-center" style="color: snow;  margin-top: 0px;"><strong>Buildbot and Apache</strong></h3>
                        </div>
                        
                    </div>
                </div>
                <div>
                    <div class="uk-card uk-card-muted uk-card-body" style="padding-top: 0px; padding-bottom: 0px;">
                        <div class="pa2">
                            <span class="text-white">
                            <img src="../../assets/trac.png"  width="60" height="60" alt="svg" style="padding-top: 10px"></span>
                            <h3 class="uk-text-center" style="color: snow;  margin-top: 0px;"><strong>Roundup </strong></h3>
                            
                        </div>
                        
                    </div>
                </div>
            </div>
            
        </div>
    </div>

    <h1 class="uk-text-center" style="margin-bottom: 0px;"><span>Related Services</span></h1>
    <BR><BR>
        
    <div class="uk-container">
        <div class="uk-grid-small uk-child-width-1-2@s  uk-child-width-1-4@m  uk-flex-center uk-grid-match" uk-grid>
            <div>
                <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;" >
                
                    <img class=" uk-align-center" src="../../assets/icons/cbg11.png" width="100" height="100" alt="">
                    <h4 class="uk-text-center" style="font-weight: 600;">Custom Business<br> Application</h4>
            
                </div>
            </div>
        

            <div>
        
                <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;">
                    <img class="uk-align-center" src="../../assets/icons/phpg5.png" width="100" height="100" alt="">
                    <h4 class="uk-text-center" style="font-weight: 600;">Php Application<br> Development</h4>

            
                </div>
            </div>


            <div>
        
                <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;">
                    <img class=" uk-align-center" src="../../assets/icons/laravelg6.png" width="100" height="100"
                        alt="">
                    <h4 class="uk-text-center" style="font-weight: 600; ">Laravel Application<br>Development</h4>
                </div>
            
            </div>
        

            <div>
                <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium "style="padding-top: 30px;" >
                    <img class="uk-align-center" src="../../assets/icons/cakeg8.png" width="100" height="100" alt="">
                    <h4 class="uk-text-center" style="font-weight: 600;">CakePhp Application Development</h4>

            
                </div>
            </div>

            <div>
        
                <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;">
                    <img class=" uk-align-center" src="../../assets/icons/pythong4.png" width="100" height="100" alt="">
                    <h4 class="uk-text-center" style="font-weight: 600;">Python <br>Programming </h4>

            
                </div>
            </div>

            <div>
                <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;">
                    <img class=" uk-align-center" src="../../assets/icons/shopifyg7.png" width="100" height="100" alt="">
                    <h4 class="uk-text-center" style="font-weight: 600;">Ecommerce Web <br>Development</h4>

            
                </div>
            </div>

        
            <div>
                <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;">
                    <img class=" uk-align-center" src="../../assets/icons/webdesigng12.png" width="100" height="100" alt="">
                    <h4 class="uk-text-center" style= "font-weight: 600;">Web Design <br>And Development</h4>

                </div>
            </div>
        
        </div>

    </div>
    <h1 class="uk-text-center"><span>Technology Stack</span></h1>
    <br>
    <div class="uk-container">
        <div class=" wss uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match" uk-grid>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/thsss.jpg" width="90" height="90"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">WordPress</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/web3.png" width="90" height="90"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">Angular js</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/Postgresql.png" width="90" height="90"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">Postgres SQL</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/html.jpg" width="90" height="90"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">Html</h4>
                </div>
            </div>
        </div>
        <div class="wss uk-child-width-1-4@s uk-margin-large uk-grid-match" uk-grid>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/css-3.png" width="90" height="90"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">CSS</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/Redis.png" width="120" height="120"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">Redis</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/js-logo.png" width="90" height="90"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">JavaScript</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/jest.png" width="100" height="90"
                        alt="border-circle" style="height: 90px;">
                    <h4 style="font-weight: 600;">Jest</h4>
                </div>
            </div>
        </div>
        <div class="wss uk-child-width-1-4@s uk-margin-large uk-grid-match" uk-grid>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/logo.png" width="90" height="90"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">Redux</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/ruby.jpg" width="90" height="90"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">Ruby On Rails</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/aws.png" width="130" height="130"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">AWS</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/ng.jpg" width="80" height="80"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">Nginx</h4>
                </div>
            </div>
        </div>
    </div>
    <br>   
       
       
    
